"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9938],{

/***/ 79938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ review_cards_reviews_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-component.scss.js


var StyledReviewCardsReviewsComponentDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kcy6s90"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.full-paragraph-component .full-paragraph-wrapper{max-width:unset;}.cards{margin:auto;display:flex;justify-content:center;text-align:center;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/default-props.js


/* harmony default export */ var default_props = ({
    fullParagraph: {
        title: "<light>An </light>award-winning <light>platform.</light> Loved <light>by customers.</light>",
        body: "Based on 10,000+ customer reviews.",
        topic: {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/review-cards/stars.png",
                alt: "5 full stars rating"
            }
        },
        buttonConfig: {
            buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge
        },
        textAlign: "center",
        topicBottomMargin: "40px",
        spaceFromParagraph: "40px",
        buttonTopMargin: "44px"
    },
    cards: [
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/review-cards/trust.png",
                alt: "TrustRadius badge of Best Feature Set 2022"
            },
            title: "Voted best feature set, relationship and value",
            subtitle: "“This is the best no-code platform I've ever seen.”"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/review-cards/forrester.png",
                alt: "Forrester logo"
            },
            title: "345% uplift in ROI",
            subtitle: "The Total Economic Impact™ Report"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/review-cards/capterra.png",
                alt: "Capterra shortlist 2022 badge"
            },
            title: "Shortlisted in over 8 software categories",
            subtitle: "“The perfect organizer and team builder.”"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/review-cards/g2.png",
                alt: "G2 Leader winter 2022 badge"
            },
            title: "Market leader across 18 categories",
            subtitle: "Flexbile product with near endless possibilities."
        }
    ],
    titleSize: sizes.LG,
    marginAboveCards: "40px"
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-mobile-component/review-cards-reviews-mobile-component.scss.js

var StyledReviewCardsReviewsComponentMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yfjimw0"
})("display:flex;flex-direction:column;.paragraph-and-topic{padding:0px 32px;.topic-wrapper{display:flex;justify-content:center;margin-top:var(--topic-margin);img{max-width:124px;}}.carousel-wrapper{margin-top:var(--margin-above-cards);}}.card-item{padding:0 20px;.card{margin-left:0;margin-right:0;padding:24px;.top-image{img{max-width:160px;}}.title{margin-bottom:8px;}.title,.subtitle{font-size:0.875rem;}}}");

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-card-reviews-component/review-card-reviews-component.scss.js






var CARD_WIDTH = 286;
var CARD_BORDER_RADIUS = 8;
var CARD_VERTICAL_PADDING = 32;
var CARD_HORIZONTAL_PADDING = 20;
var CARD_IMAGE_HEIGHT = 100;
var StyledReviewCardComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vqu1ux0"
})("width:", CARD_WIDTH, "px;z-index:", z_index/* LAYER_ONE */.KW, ";margin:32px 10px 0;padding:", CARD_VERTICAL_PADDING, "px;border-radius:", CARD_BORDER_RADIUS, "px;background-color:white;", (0,constants.getComponentShadow)(), "  &:hover{", (0,constants.getComponentShadowWithHoverEffect)(), "}transition:filter 0.2s ease-in-out;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";position:relative;.top-image{align-items:center;justify-content:center;display:flex;margin-bottom:16px;height:", CARD_IMAGE_HEIGHT, "px;img{max-height:", CARD_IMAGE_HEIGHT, "px;max-width:", CARD_WIDTH - CARD_HORIZONTAL_PADDING * 4, "px;}}.title{font-size:1.125rem;line-height:24px;letter-spacing:-0.5px;font-weight:500;margin-bottom:24px;min-height:64px;}.subtitle{font-size:1rem;line-height:24px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){width:unset;text-align:center;padding:", CARD_VERTICAL_PADDING, "px;filter:unset;&:hover{filter:unset;}.title{font-size:1rem;}}");

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-card-reviews-component/review-card-reviews-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var ReviewCardComponent = function(param) {
    var reviewCardProps = param.reviewCardProps;
    var image = reviewCardProps.image, subtitle = reviewCardProps.subtitle, title = reviewCardProps.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReviewCardComponent, {
        className: "card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "top-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({}, image))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "subtitle",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ var review_card_reviews_component = (ReviewCardComponent);

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-mobile-component/review-cards-reviews-mobile-component.js
function review_cards_reviews_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function review_cards_reviews_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            review_cards_reviews_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var ReviewCardsReviewsComponentMobileComponent = function(props) {
    var fullParagraph = props.fullParagraph, marginAboveCards = props.marginAboveCards, cards = props.cards, spaceFromParagraph = props.spaceFromParagraph, buttonTopMargin = props.buttonTopMargin, titleSize = props.titleSize, textSize = props.textSize;
    var topic = fullParagraph.topic, buttonConfig = fullParagraph.buttonConfig, topicBottomMargin = fullParagraph.topicBottomMargin, fullParagraphForMobile = _object_without_properties(fullParagraph, [
        "topic",
        "buttonConfig",
        "topicBottomMargin"
    ]);
    var fullParagraphAdvancedProps = {
        spaceFromParagraph: spaceFromParagraph,
        buttonTopMargin: buttonTopMargin,
        titleSize: titleSize,
        textSize: textSize,
        topic: {}
    };
    var itemRenderer = function(card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "card-item",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(review_card_reviews_component, {
                reviewCardProps: card
            })
        });
    };
    var carouselProps = {
        items: cards,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        autoplaySpeed: 5000,
        centerPadding: "15%"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReviewCardsReviewsComponentMobileComponent, {
        className: "review-cards-reviews-mobile-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "paragraph-and-topic",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "paragraph-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, review_cards_reviews_mobile_component_object_spread({}, fullParagraphForMobile, fullParagraphAdvancedProps))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "topic-wrapper",
                        style: {
                            "--topic-margin": topicBottomMargin
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, review_cards_reviews_mobile_component_object_spread({}, topic === null || topic === void 0 ? void 0 : topic.image))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-wrapper",
                style: {
                    "--margin-above-cards": marginAboveCards
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, review_cards_reviews_mobile_component_object_spread({}, carouselProps))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-component.js
function review_cards_reviews_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function review_cards_reviews_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            review_cards_reviews_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var ReviewCardsReviewsComponentDesktopComponent = function(props) {
    var fullParagraph = props.fullParagraph, marginAboveCards = props.marginAboveCards, cards = props.cards, spaceFromParagraph = props.spaceFromParagraph, topicBottomMargin = props.topicBottomMargin, buttonTopMargin = props.buttonTopMargin, titleSize = props.titleSize, textSize = props.textSize;
    var fullParagraphAdvancedProps = {
        spaceFromParagraph: spaceFromParagraph,
        topicBottomMargin: topicBottomMargin,
        buttonTopMargin: buttonTopMargin,
        titleSize: titleSize,
        textSize: textSize
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReviewCardsReviewsComponentDesktopComponent, {
        className: "review-cards-reviews-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "paragraph",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, review_cards_reviews_component_object_spread({}, fullParagraph, fullParagraphAdvancedProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cards",
                style: {
                    marginTop: marginAboveCards
                },
                children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(review_card_reviews_component, {
                        reviewCardProps: card
                    }, index);
                })
            })
        ]
    });
};
var ReviewCardsReviewsComponent = (0,responsive_hoc_component/* default */.Z)(ReviewCardsReviewsComponentDesktopComponent, ReviewCardsReviewsComponentMobileComponent);
ReviewCardsReviewsComponent.defaultProps = default_props;
/* harmony default export */ var review_cards_reviews_component = (ReviewCardsReviewsComponent);


/***/ })

}]);